<template>
	<div>
        <template v-if="loadingAlumni">
            <div class="div__loading">
                <loader />
            </div>
        </template>
        <template>
            <div class="bg-grey">
                <section class="section bg-grey">
                    <div class="container">
                        <h3 class="section__title section__title--left">Alumni Network</h3>
                        <h5 class="section__title--sub">Become an alumni by joining us today</h5>
                    </div>
                </section>
                <section class="section alumni">
                    <template v-if="alumni && alumni.length > 0">
                        <div class="container">
                            <ul class="nav__tabs">
                                <li class="nav__tabs__item active head"><a href="">All</a></li>
                                <li class="nav__tabs__item"><a href="">A</a></li>
                                <li class="nav__tabs__item"><a href="">B</a></li>
                                <li class="nav__tabs__item"><a href="">C</a></li>
                                <li class="nav__tabs__item"><a href="">d</a></li>
                                <li class="nav__tabs__item"><a href="">e</a></li>
                                <li class="nav__tabs__item"><a href="">f</a></li>
                                <li class="nav__tabs__item"><a href="">g</a></li>
                                <li class="nav__tabs__item"><a href="">h</a></li>
                                <li class="nav__tabs__item"><a href="">i</a></li>
                                <li class="nav__tabs__item"><a href="">j</a></li>
                                <li class="nav__tabs__item"><a href="">k</a></li>
                                <li class="nav__tabs__item"><a href="">l</a></li>
                                <li class="nav__tabs__item"><a href="">m</a></li>
                                <li class="nav__tabs__item"><a href="">n</a></li>
                                <li class="nav__tabs__item"><a href="">o</a></li>
                                <li class="nav__tabs__item"><a href="">p</a></li>
                                <li class="nav__tabs__item"><a href="">q</a></li>
                                <li class="nav__tabs__item"><a href="">r</a></li>
                                <li class="nav__tabs__item"><a href="">s</a></li>
                                <li class="nav__tabs__item"><a href="">t</a></li>
                                <li class="nav__tabs__item"><a href="">u</a></li>
                                <li class="nav__tabs__item"><a href="">v</a></li>
                                <li class="nav__tabs__item"><a href="">w</a></li>
                                <li class="nav__tabs__item"><a href="">x</a></li>
                                <li class="nav__tabs__item"><a href="">y</a></li>
                                <li class="nav__tabs__item"><a href="">z</a></li>
                            </ul>
                            <div class="main__grid alumni__grid">
                                <div
                                    class="alumni__item"
                                    v-for="item in alumni"
                                    :key="item.id"
                                >
                                    <div class="">
                                        <img v-if="item.user.avatar" class="post__img" :src="item.user.avatar" alt="">
                                        <img v-else class="post__img" src="../../assets/img/profile.jpg" alt="">
                                    </div>
                                    <router-link
                                        :to="{
                                            name: 'alumni-profile',
                                            params: { id: item.user.id }
                                        }"
                                        class="text">
                                        {{ item.user.fname + ' ' + item.user.lname }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="section__footer">
                                <Pagination 
                                    v-if="total > limit"
                                    :options="{ limit, offset, total, baseUrl }"/>
                            </div>
                        </div>
                    </template>
                </section>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getAlumniList } from '../../utils/api/alumni';
import Loader from '../../components/Loader';
import Pagination from '../../components/Pagination';
import { success } from '../../utils/toast';

export default {
	name: 'Index',
	data() {
		return {
			loadingAlumni: true,
			alumniLoaded: false,
			alumni: [],
			limit: 6,
			offset: 0,
			total: 0,
			baseUrl: 'alumni'
		};
	},
	mounted() {
		if (this.userObject.is_credential_uploaded !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly update your credentials to proceed, you are being redirected.', 
				timer: 8000 
			});
			setTimeout(() => {
				this.$router.push({ name: 'user-profile', params: { id: this.$session.get('id') } });
			}, 5000);
		} else if (this.userObject.is_psychometric_completed !== 1) {
			success({
				title: 'Notice!',
				text: 'Kindly complete your psychometirc tests to continue, you are being redirected.', 
				timer: 8000
			});
			setTimeout(() => {
				this.$router.push({ name: 'test' });
			}, 5000);
		}
	},
	created() {
		this.getAlumniList();
		this.limit = this.$route.query.limit ? this.$route.query.limit : this.limit;
		this.offset = this.$route.query.offset ? this.$route.query.offset : this.offset;
		if (this.$session.get('category') === 'employer') {
			this.$router.push('/jobs');
		}
	},
	methods: {
		getAlumniList() {
			getAlumniList(this.limit, this.offset)
				.then((response) => {
					if (response.status === 200) {
						this.alumni = response.data.data;
						this.total = response.data.total;
						this.alumniLoaded = true;
						return true;
					}
					this.alumniLoaded = false;
					return false;
				}).catch(() => {
					this.alumniLoaded = false;
					return false;
				}).finally(() => {
					this.loadingAlumni = false;
				});
		}
	},
	computed: {
		...mapGetters([
			'userObject'
		])
	},
	components: {
		Loader,
		Pagination
	}
};
</script>

<style scoped>
.div__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
